import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// Benign browser warning that the dev overlay shows as a crash; ignore it.
window.addEventListener("error", (e) => {
    if (String(e.message || "").includes("ResizeObserver loop")) e.stopImmediatePropagation();
});
root.render(
    <QueryClientProvider client={queryClient}>
        <App />
    </QueryClientProvider>,
);

// Register service worker for PWA support (production only — CRA dev server
// hot reload doesn't play nicely with SW caching).
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("SW registration failed:", err));
  });
}
